import styled from 'styled-components';

export const Contain = styled.div`
  height: 100%;
  text-align: center;
  width: 50%;
  margin: auto;
`;

export const Image = styled.img`
  height: 50%;
  width: 60%;
  margin: auto;
`;

export const Titulo = styled.h1`
  color: #263238;
  font-weight: bold;
  font-size: 80pt;
  margin-bottom: 0px;
  text-align: center;
`;

export const Subtitulo = styled.p`
  color: #263238;
  font-weight: bold;
  font-size: 12pt;
  margin: 0px;
  margin-bottom: 33px;
  text-align: center;
`;
